// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3hp5M","inner":"Footer_inner__vXLPT","nextIcon":"Footer_nextIcon__2ijS_","innerLeft":"Footer_innerLeft__3mbiX"};